/* bf26s-preset.js (7 Oct 2026, sets2; first version 6 Oct). Sets. A set adds its COMPONENT lines in ONE /cart/add.js call, so the ladder, perks,
   checkout gate and Bundle Builder all work on normal cart lines. Data: <script data-bf26s> on the set product pages (metafield bf26.set_items) or the tile data on the Sets page.
   mode 'colour': every component gets the variant whose Color/Colour matches the set's chosen Colour. mode 'self': the set product's own variants are added once each.
   Lines carry _bf_set (+ _bf_bundle when bundle is true). The wash bag is NOT added here for other sets: the ladder perk adds it (BF26Cart.perks) at 3 pieces.
   13 Oct 2026 (price pass): the RKKN Set DOES add its wash bag line (1 x wash-bag, first variant) so every route matches /pages/rkkn-set: 2 gloves, 2 socks, SoftClip 2-Pack, wash bag = 6 pieces. Backup: assets/bf26s-preset-bak-20261013-price.js
   13 Oct 2026 (glove sets): the 3-Pack Glove Sets (mode 'self', titles end in "3-Pack Set" or "3-Pack Glove Set") now also add one wash-bag line, as the RKKN Set does, so the card's "+free wash bag" tag is true. The existing Free Washbag discount takes it to $0 (checked with a real add: set $84, bag $0). Backup: assets/bf26s-preset-bak-20261013-gloveset-bag.js
   1 Nov 2026 (paired sets): an item may carry "colours": {"<set colour>": "<that item's colour>"} (e.g. the Pink Stripey RKKN Set adds Rosé gloves,
   Pink Stripey socks and an Oat SoftClip 2-Pack); without it the item uses the set's colour. The wash bag line is added for any colour set that lists
   wash-bag in its items (the RKKN Set and the RKKN Stripey and Ballet Sets), which is what the old "RKKN Set" title test did for the RKKN Set.
   window.BF26Set.lines(cfg, colour) is used by the Sets page (bf26s-builder.js). On a set product page the native buy button runs the same lines, refreshes the drawer and OPENS it. */
(function () {
  if (window.BF26Set) return;
  var cache = {};
  function prod(h) {
    return cache[h] || (cache[h] = fetch('/products/' + h + '.js').then(function (r) {
      if (!r.ok) throw new Error('Sorry, one of the pieces is not available right now.');
      return r.json();
    }));
  }
  function ctx(f) {
    for (var n = f; n && n.querySelector; n = n.parentNode) {
      var s = n.querySelector('script[data-bf26s]');
      if (s) { try { return { cfg: JSON.parse(s.textContent), box: n }; } catch (e) { return null; } }
    }
    return null;
  }
  function friendly(e) { var m = e && e.message; return !m || /fetch|network|load|json|unexpected|undefined|null/i.test(m) ? 'Sorry, we could not add the set. Please try again.' : m; }
  function say(x, t) { var m = x.box.querySelector('[data-bf26s-msg]'); if (m) m.textContent = t; else if (t) alert(t); }
  function props(c, p) { p = p || {}; p._bf_set = c.title; if (c.bundle) p._bf_bundle = '1'; return p; }
  function lines(c, colour) {
    if (c.mode === 'self') {
      var out = c.variants.filter(function (v) { return !v.available; });
      if (out.length) throw new Error('Sorry, this set is sold out right now (' + out.map(function (v) { return v.title; }).join(', ') + ').');
      var own = c.variants.map(function (v) { return { id: v.id, quantity: 1, properties: props(c) }; });
      if (!/3-Pack (Glove )?Set$/.test(c.title)) return own;
      return prod('wash-bag').then(function (p) {
        var wv = p.variants.filter(function (x) { return x.available; })[0];
        if (wv) own.push({ id: wv.id, quantity: 1, properties: props(c) });
        return own;
      });
    }
    /* 2 Nov 2026 (new glove sets): an item may carry "pick": ["Black","Oat","Rosé"] (fixed colours, one unit each: Best-Seller 3-Pack, The Original 5-Pack)
       or "choose": true (the shopper picks one colour per unit on the Sets card: Pick Your Own 3-Pack; the card puts them in c.choice). */
    var comps = [];
    c.items.forEach(function (i) {
      if (i.handle === 'wash-bag') return;
      var cols = (i.pick && i.pick.length) ? i.pick : (i.choose ? (c.choice || []) : null);
      if (i.choose && cols.length < (i.qty || 1)) throw new Error('Please pick a colour for each pair.');
      if (cols) cols.forEach(function (col) { comps.push({ handle: i.handle, qty: 1, fixed: col }); });
      else comps.push(i);
    });
    if (c.items.some(function (i) { return i.handle === 'wash-bag'; })) comps.push({ handle: 'wash-bag', qty: 1 });
    return Promise.all(comps.map(function (i) { return prod(i.handle); })).then(function (ps) {
      var bad = [], items = [];
      ps.forEach(function (p, k) {
        var oi = -1;
        p.options.forEach(function (o, j) { if (/colou?r/i.test(o.name || o)) oi = j; });
        var norm = function (s) { return String(s).toLowerCase().replace(/ - sold out$/, '').replace('é', 'e'); };
        var want = comps[k].fixed || (comps[k].colours && comps[k].colours[colour]) || colour;
        var v = p.variants.filter(function (x) { return oi < 0 || norm(x['option' + (oi + 1)]) === norm(want); })[0];
        if (!v || !v.available) bad.push(p.title + ' in ' + want);
        else items.push({ id: v.id, quantity: comps[k].qty || 1, properties: props(c) });
      });
      if (bad.length) throw new Error('Sorry, sold out right now: ' + bad.join(', ') + '. Please choose another colour.');
      return items;
    });
  }
  window.BF26Set = { lines: function (c, colour) { return Promise.resolve().then(function () { return lines(c, colour); }); } };

  /* set product pages: the native buy button adds the component lines, refreshes the drawer and opens it (never a redirect to /cart) */
  function close(f) {
    var m = f.closest('quick-add-modal'); if (!m) return;
    try { m.hide(true); } catch (e) { m.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }
  }
  function run(x, vid, f) {
    var C = window.BF26Cart, b = f.querySelector('[type=submit]'), r = x.box.querySelector('input[type=radio]:checked'),
      v = x.cfg.variants.filter(function (y) { return r ? y.title.toLowerCase() === r.value.toLowerCase() : y.id == vid; })[0] || x.cfg.variants[0];
    say(x, ''); if (b) b.setAttribute('aria-disabled', 'true');
    /* 2 Nov 2026: Pick Your Own packs read the colour menus in the set panel (snippets/bf26s-set-panel.liquid) */
    var picks = [].slice.call(x.box.querySelectorAll('[data-bs-pick]')).map(function (s) { return s.value; });
    if (picks.length) x.cfg.choice = picks;
    window.BF26Set.lines(x.cfg, v.title)
      .then(function (items) { return C.req('/cart/add.js', { items: items, sections: 'cart-drawer,cart-icon-bubble' }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.d && r.d.description) || 'Sorry, we could not add the set. Please try again.');
        C.drawer(r.d);
        close(f);
        return window.bf26gLadder ? window.bf26gLadder.refresh() : 0;
      })
      .then(function () { C.openDrawer(); })
      .catch(function (e) { say(x, friendly(e)); }) /* r55 (FX1, Q2-29): never the raw browser error ('Failed to fetch') */
      .then(function () { if (b) b.removeAttribute('aria-disabled'); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target, id = f && f.querySelector && f.querySelector('[name=id]'), x = id && ctx(f);
    if (!x || !x.cfg.variants.some(function (y) { return y.id == id.value; })) return;
    e.preventDefault(); e.stopImmediatePropagation();
    run(x, id.value, f);
  }, true);
})();
